import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '今使っている機械の引取が可能か?',
      answer: '納品時に限り別途11,000円(税込)にてお引取り可能です。ただし、機種が旧取品でなくリース物件の場合は、事前にお客様からリース会社へ、弊社にて引取り作業を行う承認をお取りいただきます。'
    },
    {
      question: '毎月の保守料金には何が含まれているか?',
      answer: '不具合時の訪問修理費、部品交換費、トナー代が含まれています。\n紙詰まりなどになりますので、お客様にてご準備が必要です。'
    },
    {
      question: 'レンタルする機械は選べるか?',
      answer: 'こちらは、お客様のご利用環境によってこちらで選定させていただきます。基本的には、現状の利用状況に合う機種、又は将来ご利用の際合格より「年式が新しく」、「スペックを下げない」という条件で機器選定致します。'
    },
    {
      question: 'アフターサポートはどのような対応か?',
      answer: 'シャープ・富士フイルム・京セラのメーカー限定設定を持った、協力会社のサービスマンが、保守対応をさせていただきます。\n\n休中サービス受付時間：平日・土曜9：00～17：30\n※日曜・祝日・年末年始は休業となります'
    },
    {
      question: '申込から納品までの期間はどのくらいか?',
      answer: '正式ご注文後、1週間～10日程でお届けが可能です。\n在庫状況やお客様の場合は、2週間程度お時間いただく場合もございます。'
    },
    {
      question: 'Macのパソコンには対応しているか?',
      answer: '対応機種が限られているため、ヒアリングした上で、対応可能モデルをご案内致します。\nなお、スキャニングについては、別途USBメモリー・NASメサーバーをご用意いただく必要がございます。'
    },
    {
      question: '設置数年後、機械が古くなった場合は?',
      answer: '故障頻度が増え、修理が間で不可能しない場合は、無料で機械をお入替え致します。なお、お客様都合でのお入替え(「Macの対応を導入したので、対応機種に変更したい」等)は再度契約し直しとなりうえで、お入替え可能です。'
    },
    {
      question: '途中解約した場合の違約金はかかるか?',
      answer: '0円コピーは「定期・無期」の利用を前提としたレンタルサービスです。\n設置から1年未満での解約の際には、【最低基本料金4,400円(税込)×残期間分】を違約金として頂戴します。'
    },
    {
      question: '事務所の移転で保守エリアが変更になった際は、保守料金も変更になるか?',
      answer: '移転先の保守料金に変更となります。'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl mb-4" style={{ fontFamily: 'serif' }}>
            <a href="#faq" className="hover:text-[#14B8A6] transition-colors cursor-pointer">
              よくある質問
            </a>
          </h2>
          <p className="text-gray-600">
            お客様からよくいただくご質問をまとめました
          </p>
        </div>

        <div className="space-y-4 mb-12">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-lg overflow-hidden hover:border-[#14B8A6] transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-medium text-gray-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-[#14B8A6] transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-5 bg-gray-50 border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed whitespace-pre-line">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-gray-600 mb-6">その他のご質問がございましたら、お気軽にお問い合わせください</p>
          <button
            onClick={scrollToContact}
            className="bg-[#14B8A6] text-white px-8 py-4 rounded-lg font-medium hover:bg-[#0F9B8E] transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            お問い合わせはこちら
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
